// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Instagram-style inbox layout */
.chat-history-overview {
  width: 100%;
  height: 600px;
  display: flex;
  font-family: "DM Sans", sans-serif;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

/* ========== LEFT SIDEBAR - Chat List ========== */
.chat-sidebar {
  width: 320px;
  min-width: 320px;
  border-right: 1px solid #efefef;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.chat-sidebar-header {
  padding: 12px 20px;
  padding-right: 8px;
  border-bottom: 1px solid #efefef;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  min-height: 56px;
  height: 56px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.header-title {
  transition: opacity 0.2s ease, width 0.2s ease;
  white-space: nowrap;
}

.header-title.hidden {
  opacity: 0;
  width: 0;
  overflow: hidden;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.search-container.expanded {
  flex: 1 1;
}

.search-input {
  width: 0;
  padding: 0;
  border: none;
  background: #f5f5f5;
  border-radius: 8px;
  font-size: 14px;
  font-family: "DM Sans", sans-serif;
  outline: none;
  transition: all 0.3s ease;
  opacity: 0;
}

.search-container.expanded .search-input {
  width: 100%;
  padding: 8px 12px;
  opacity: 1;
}

.search-input:focus {
  background: #efefef;
}

.search-input::placeholder {
  color: #8e8e8e;
}

.search-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #262626;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.2s ease;
  flex-shrink: 0;
  outline: none;
}

.search-toggle:hover {
  background: #f5f5f5;
  color: #5616ea;
}

.chat-list {
  flex: 1 1;
  overflow-y: auto;
}

.chat-list-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  color: #5616ea;
  font-size: 18px;
}

.chat-list-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #fafafa;
}

.chat-list-item:hover {
  background-color: #fafafa;
}

.chat-list-item.active {
  background-color: #f0f0f0;
}

.chat-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5616ea 0%, #8b5cf6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.chat-avatar-icon {
  color: white;
  font-size: 16px;
}

.chat-avatar.facebook {
  background: linear-gradient(135deg, #1877f2 0%, #42a5f5 100%);
}

.chat-avatar.instagram {
  background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
}

.chat-avatar.whatsapp {
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
}

.chat-avatar.telegram {
  background: linear-gradient(135deg, #229ED9 0%, #16BFFD 100%);
}

.chat-avatar.slack {
  background: linear-gradient(135deg, #2EB67D 0%, #36C5F0 100%);
}

.chat-item-content {
  flex: 1 1;
  min-width: 0;
}

.chat-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.chat-item-name {
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-item-time {
  font-size: 12px;
  color: #8e8e8e;
  flex-shrink: 0;
  margin-left: 8px;
}

.chat-item-preview {
  font-size: 14px;
  color: #8e8e8e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-item-bot {
  display: inline-block;
  font-size: 11px;
  background-color: #f0f0f0;
  color: #666;
  padding: 2px 8px;
  border-radius: 10px;
}

.chat-list-item.active .chat-item-bot {
  background-color: #e0e0e0;
}

.chat-item-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
}

.auto-response-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.auto-response-dot.enabled {
  background-color: #155724;
  box-shadow: 0 0 0 2px #d4edda;
}

.auto-response-dot.disabled {
  background-color: #721c24;
  box-shadow: 0 0 0 2px #f8d7da;
}

.chat-item-country-flag {
  width: 16px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
  object-fit: cover;
}

.chat-header-country-flag {
  width: 24px;
  height: 18px;
  border-radius: 3px;
  flex-shrink: 0;
  object-fit: cover;
}

/* ========== RIGHT SIDE - Chat View ========== */
.chat-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  min-width: 0;
}

.chat-main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid #efefef;
  background-color: #fff;
  min-height: 56px;
  height: 56px;
  box-sizing: border-box;
}

.chat-main-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.chat-main-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5616ea 0%, #8b5cf6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat-main-avatar-icon {
  color: white;
  font-size: 16px;
}

.chat-main-avatar.facebook {
  background: linear-gradient(135deg, #1877f2 0%, #42a5f5 100%);
}

.chat-main-avatar.instagram {
  background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
}

.chat-main-avatar.whatsapp {
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
}

.chat-main-info h3 {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin: 0;
}

.chat-main-info span {
  font-size: 12px;
  color: #8e8e8e;
}

/* Auto-response toggle in header */
.auto-response-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toggle-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #666;
}

/* In place of the AI switch when the chat's channel is no longer connected to the agent */
.inbox-channel-disconnected {
  font-size: 13px;
  color: #666;
  text-align: right;
  max-width: 320px;
}

.toggle-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.toggle-button.enabled {
  background-color: #d4edda;
  color: #155724;
}

.toggle-button.enabled:hover {
  background-color: #c3e6cb;
}

.toggle-button.disabled {
  background-color: #f8d7da;
  color: #721c24;
}

.toggle-button.disabled:hover {
  background-color: #f5c6cb;
}

.toggle-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.toggle-button svg {
  font-size: 16px;
}

/* Chat messages container with sticky header */
.chat-messages-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  min-height: 0;
}

/* Sticky date header */
.chat-sticky-date {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  margin: 0 0 -28px 0;
  pointer-events: none;
}

.chat-sticky-date.hidden {
  visibility: hidden;
}

.chat-sticky-date-text {
  background-color: #f0f0f0;
  color: #8e8e8e;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 12px;
  border-radius: 12px 12px 8px 12px;
}

/* Date separator between message groups */
.chat-date-separator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  margin: 4px 0;
  width: 100%;
  box-sizing: border-box;
}

/* First date separator should have no top margin */
.chat-date-separator:first-child {
  margin-top: 0;
  padding-top: 0;
}

.chat-date-separator-text {
  background-color: #f0f0f0;
  color: #8e8e8e;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 12px;
  border-radius: 12px;
  transition: opacity 0.15s ease;
  opacity: 1;
}

/* Hide separator text when it's at the sticky position - use opacity for smooth transition */
.chat-date-separator.at-sticky .chat-date-separator-text {
  opacity: 0;
}

/* Chat messages area */
.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #fff;
}

.chat-message {
  display: flex;
  flex-direction: column;
}

.chat-message.assistant-message {
  align-self: flex-start;
  align-items: flex-start;
  width: 100%;
}

.chat-message.user-history-message {
  align-self: flex-end;
  align-items: flex-end;
  flex-direction: column;
  gap: 6px;
  max-width: none;
}

/* Stack user row and timestamp; align to the right */
.user-message-group {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

/* Keep FAQ button and bubble aligned on the same center line */
.user-message-body {
  display: flex;
  align-items: center;
  gap: 8px;
}

.message-bubble-history {
  padding: 6px 10px !important;
  border-radius: 12px;
  font-size: 15px;
  line-height: 1.4;
  word-wrap: break-word;
  background-color: #efefef;
  color: #262626;
}

.user-history-message .message-bubble-history {
  background-color: #5616ea;
  color: #fff;
  border-bottom-right-radius: 4px;
}

.assistant-message .message-bubble-history {
  background: #efefef;
  color: #262626;
  font-size: 16px;
  line-height: 1.5;
  padding: 6px 10px !important;
  border-radius: 12px 12px 12px 4px;
  max-width: 70%;
}

/* Match chatModal bot markdown spacing */
.assistant-message .message-bubble-history p {
  margin: 0 0 .9em;
}

.assistant-message .message-bubble-history h1,
.assistant-message .message-bubble-history h2,
.assistant-message .message-bubble-history h3,
.assistant-message .message-bubble-history h4,
.assistant-message .message-bubble-history h5,
.assistant-message .message-bubble-history h6 {
  font-size: 1em;
  line-height: inherit;
  margin: 0 0 .9em;
}

.assistant-message .message-bubble-history ul,
.assistant-message .message-bubble-history ol {
  margin: .9em 0;
  padding-left: 1.25em;
}

.assistant-message .message-bubble-history li {
  margin: .25em 0;
}

.assistant-message .message-bubble-history table {
  margin: .9em 0;
}

.assistant-message .message-bubble-history > :first-child {
  margin-top: 0;
  padding-top: 0;
}

.assistant-message .message-bubble-history > :last-child {
  margin-bottom: 0;
  padding-top: 0;
}

.assistant-message .message-bubble-history a {
  color: #5616ea;
  font-weight: 500;
  text-decoration: underline;
}

.user-history-message .message-bubble-history a {
  color: #fff;
}

.message-bubble-history p {
  margin: 0;
}

.message-bubble-history strong {
  font-weight: 600;
}

.message-bubble-history em {
  font-style: italic;
}

.message-bubble-history a {
  color: #5616ea;
  text-decoration: underline;
}

.message-bubble-history ul,
.message-bubble-history ol {
  padding-left: 20px;
  margin: 8px 0;
}

.message-bubble-history li {
  margin-bottom: 4px;
}

.message-bubble-history code {
  background-color: rgba(0, 0, 0, 0.05);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 13px;
}

.message-bubble-history table {
  border-collapse: separate;
  border-spacing: 0;
  margin: 10px 0;
  width: 100%;
  font-size: 13px;
  border-radius: 8px;
  overflow: hidden;
}

.message-bubble-history th,
.message-bubble-history td {
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: 6px 10px;
  text-align: left;
}

.message-bubble-history th {
  background-color: rgba(0, 0, 0, 0.04);
  font-weight: 600;
}

/* Message content wrapper for user messages */
.message-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.message-time {
  font-size: 11px;
  color: #8e8e8e;
  padding: 0px;
  margin-bottom: 4px;
  margin-top: 4px;
}

.assistant-message .message-time {
  align-self: flex-start;
}

.user-history-message .message-time {
  align-self: flex-end;
}

/* Sources */
.sources-container {
  margin: 0;
}

.sources-button {
  background: none;
  border: 1px solid #dbdbdb;
  color: #666;
  cursor: pointer;
  font-size: 11px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 4px 10px;
  outline: none;
  transition: all 0.2s ease;
}

.sources-button:hover {
  background: #fafafa;
  border-color: #c0c0c0;
}

.sources-toggle-icon {
  margin-left: 6px;
  font-size: 10px;
}

.sources-list {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: all 0.2s ease;
}

.sources-list.expanded {
  max-height: 200px;
  opacity: 1;
  margin-top: 6px;
}

.source-link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  margin-bottom: 4px;
  background: #fafafa;
  border-radius: 8px;
  font-size: 11px;
  color: #5616ea;
  text-decoration: none;
  transition: background 0.2s ease;
}

.source-link:hover {
  background: #f0f0f0;
}

.globe-icon {
  font-size: 12px;
  color: #5616ea;
}

/* Add FAQ button */
.add-faq-button {
  display: flex;
  align-items: center;
  align-self: center;
  line-height: 1; /* keep text centered without relying on offsets */
  gap: 4px;
  border-radius: 14px;
  padding: 4px 10px;
  background-color: transparent;
  border: 1px solid #dbdbdb;
  color: #5616ea;
  cursor: pointer;
  font-size: 11px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.add-faq-button:hover {
  background-color: #fafafa;
  border-color: #5616ea;
}

/* Chat input area - styled like chatModal */
/* Website chats: why/until when the team can reply after the chat ended */
.followup-note {
  padding: 8px 12px;
  border-top: 1px solid #f1f1f1;
  background-color: #fafafa;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.4;
}

.followup-note a {
  color: #5616ea;
  font-weight: 600;
  text-decoration: none;
}

.followup-note a:hover {
  text-decoration: underline;
}

.followup-note + .chat-input-area {
  border-top: none;
}

.chat-input-area {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px;
  border-top: 1px solid #f1f1f1;
  background-color: #fafafa;
}

.chat-input-wrapper {
  flex: 1 1;
  display: flex;
  align-items: center;
}

.chat-input-wrapper textarea {
  flex: 1 1;
  border: 1px solid #ccc;
  background: #fff;
  padding: 6px 10px;
  font-size: 16px;
  resize: none;
  outline: none;
  font-family: "DM Sans", sans-serif;
  line-height: 1.4;
  max-height: 140px;
  overflow-y: hidden;
  border-radius: 8px;
  box-sizing: border-box;
}

.chat-input-wrapper textarea:focus {
  border-color: #5616ea;
}

.chat-input-wrapper textarea::placeholder {
  color: #8e8e8e;
}

.chat-input-wrapper textarea:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.send-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  height: 34px;
  border: none;
  border-radius: 10px;
  background-color: #5616ea;
  color: white;
  cursor: pointer;
  transition: background-color 0.4s ease, transform 0.2s ease;
  flex-shrink: 0;
}

.send-button:hover:not(:disabled) {
  background-color: #4a14d6;
  transform: translateY(-1.5px);
}

.send-button:disabled {
  background-color: #c0c0c0;
  cursor: not-allowed;
}

.send-button .send-icon {
  width: 16px;
  height: 16px;
  fill: currentColor;
  display: block;
}

/* Empty state */
.chat-empty-state {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8e8e8e;
  padding: 40px;
  text-align: center;
}

.chat-empty-state svg {
  font-size: 48px;
  margin-bottom: 16px;
  color: #dbdbdb;
}

.chat-empty-state h3 {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin: 0 0 8px 0;
}

.chat-empty-state p {
  font-size: 14px;
  margin: 0;
}

/* ========== Responsive ========== */
@media (max-width: 900px) {
  .chat-history-overview {
    height: auto;
    flex-direction: column;
    min-height: 600px;
  }

  .chat-sidebar {
    width: 100%;
    min-width: 100%;
    max-height: 280px;
    border-right: none;
    border-bottom: 1px solid #efefef;
  }

  .chat-sidebar-header {
    padding: 10px 16px;
    min-height: 48px;
    height: 48px;
  }

  .chat-main {
    flex: 1 1;
    min-height: 350px;
  }

  .chat-main-header {
    min-height: 48px;
    height: auto;
    padding: 10px 16px;
  }

  .chat-message.assistant-message,
  .chat-message.user-history-message {
    max-width: 90%;
  }

  .assistant-message .message-bubble-history {
    max-width: 100%;
  }
}

@media (max-width: 600px) {
  .chat-history-overview {
    min-height: 500px;
    border-radius: 0;
  }

  .chat-sidebar {
    max-height: 240px;
  }

  .chat-sidebar-header {
    padding: 10px 12px;
    gap: 8px;
  }

  .header-title {
    font-size: 15px;
  }

  .search-input {
    font-size: 16px; /* Prevent iOS zoom on focus */
  }

  .chat-list-item {
    padding: 10px 12px;
  }

  .chat-avatar {
    width: 38px;
    height: 38px;
    margin-right: 10px;
  }

  .chat-avatar-icon {
    font-size: 14px;
  }

  .chat-item-name {
    font-size: 13px;
  }

  .chat-item-time {
    font-size: 11px;
  }

  .chat-item-preview {
    font-size: 13px;
  }

  .chat-item-bot {
    font-size: 10px;
    padding: 2px 6px;
  }

  .chat-main-header {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    padding: 10px 12px;
  }

  .chat-main-info h3 {
    font-size: 15px;
  }

  .auto-response-toggle {
    width: 100%;
    justify-content: space-between;
  }

  .toggle-label {
    font-size: 12px;
  }

  .toggle-button {
    font-size: 11px;
    padding: 4px 8px;
  }

  .chat-messages {
    padding: 10px;
    gap: 6px;
  }

  .chat-message.assistant-message,
  .chat-message.user-history-message {
    max-width: 95%;
  }

  .message-bubble-history {
    font-size: 14px;
    padding: 5px 8px !important;
  }

  .assistant-message .message-bubble-history {
    font-size: 14px;
    max-width: 100%;
  }

  .message-time {
    font-size: 10px;
  }

  .chat-date-separator-text,
  .chat-sticky-date-text {
    font-size: 11px;
    padding: 3px 10px;
  }

  .sources-button {
    font-size: 10px;
    padding: 3px 8px;
  }

  .source-link {
    font-size: 10px;
    padding: 5px 8px;
  }

  .add-faq-button {
    font-size: 10px;
    padding: 3px 8px;
    gap: 3px;
  }

  .user-message-body {
    gap: 6px;
  }

  .chat-input-area {
    padding: 8px 10px;
    gap: 8px;
  }

  .chat-input-wrapper textarea {
    font-size: 16px; /* Prevent iOS zoom on focus */
    padding: 8px 10px;
    min-height: 36px;
  }

  .send-button {
    height: 36px;
    padding: 0 12px;
    border-radius: 8px;
  }

  .send-button .send-icon {
    width: 14px;
    height: 14px;
  }

  .chat-empty-state {
    padding: 24px 16px;
  }

  .chat-empty-state svg {
    font-size: 36px;
    margin-bottom: 12px;
  }

  .chat-empty-state h3 {
    font-size: 16px;
  }

  .chat-empty-state p {
    font-size: 13px;
  }
}

/* Extra small devices */
@media (max-width: 400px) {
  .chat-sidebar {
    max-height: 200px;
  }

  .chat-avatar {
    width: 34px;
    height: 34px;
    margin-right: 8px;
  }

  .chat-item-name {
    font-size: 12px;
  }

  .chat-item-preview {
    font-size: 12px;
  }

  .message-bubble-history {
    font-size: 13px;
  }

  .assistant-message .message-bubble-history {
    font-size: 13px;
  }
}
/* Lazy-loaded transcript states (spinner while the session's messages
   fetch, inline error + retry when that fetch fails). */
.chat-messages-state {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #5616ea;
  font-size: 18px;
}

.chat-messages-state p {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}

/* Empty search result inside the session list */
.chat-list-empty {
  padding: 24px 16px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
}

/* the product cards under an answer (ProductCarousel), as in the chat widget */
.history-products {
  width: 100%;
  max-width: 620px;
  margin-top: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/chatHistoryOverview.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,kCAAkC;EAClC,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA,0FAA0F;AAC1F;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA,6FAA6F;AAC7F;EACE,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,YAAY;AACZ;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc,EAAE,kDAAkD;EAClE,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C,0EAA0E;AAC1E;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,qCAAqC;AACrC;EACE;IACE,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,SAAO;IACP,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe,EAAE,8BAA8B;EACjD;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,eAAe,EAAE,8BAA8B;IAC/C,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;wDACwD;AACxD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* Instagram-style inbox layout */\r\n.chat-history-overview {\r\n  width: 100%;\r\n  height: 600px;\r\n  display: flex;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  background-color: #fff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n}\r\n\r\n/* ========== LEFT SIDEBAR - Chat List ========== */\r\n.chat-sidebar {\r\n  width: 320px;\r\n  min-width: 320px;\r\n  border-right: 1px solid #efefef;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #fff;\r\n}\r\n\r\n.chat-sidebar-header {\r\n  padding: 12px 20px;\r\n  padding-right: 8px;\r\n  border-bottom: 1px solid #efefef;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #262626;\r\n  min-height: 56px;\r\n  height: 56px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.header-title {\r\n  transition: opacity 0.2s ease, width 0.2s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.header-title.hidden {\r\n  opacity: 0;\r\n  width: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.search-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.search-container.expanded {\r\n  flex: 1;\r\n}\r\n\r\n.search-input {\r\n  width: 0;\r\n  padding: 0;\r\n  border: none;\r\n  background: #f5f5f5;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  outline: none;\r\n  transition: all 0.3s ease;\r\n  opacity: 0;\r\n}\r\n\r\n.search-container.expanded .search-input {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  opacity: 1;\r\n}\r\n\r\n.search-input:focus {\r\n  background: #efefef;\r\n}\r\n\r\n.search-input::placeholder {\r\n  color: #8e8e8e;\r\n}\r\n\r\n.search-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  border: none;\r\n  background: transparent;\r\n  color: #262626;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n  transition: all 0.2s ease;\r\n  flex-shrink: 0;\r\n  outline: none;\r\n}\r\n\r\n.search-toggle:hover {\r\n  background: #f5f5f5;\r\n  color: #5616ea;\r\n}\r\n\r\n.chat-list {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n}\r\n\r\n.chat-list-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px;\r\n  color: #5616ea;\r\n  font-size: 18px;\r\n}\r\n\r\n.chat-list-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 12px 20px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n  border-bottom: 1px solid #fafafa;\r\n}\r\n\r\n.chat-list-item:hover {\r\n  background-color: #fafafa;\r\n}\r\n\r\n.chat-list-item.active {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.chat-avatar {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #5616ea 0%, #8b5cf6 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-right: 12px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.chat-avatar-icon {\r\n  color: white;\r\n  font-size: 16px;\r\n}\r\n\r\n.chat-avatar.facebook {\r\n  background: linear-gradient(135deg, #1877f2 0%, #42a5f5 100%);\r\n}\r\n\r\n.chat-avatar.instagram {\r\n  background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\r\n}\r\n\r\n.chat-avatar.whatsapp {\r\n  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);\r\n}\r\n\r\n.chat-avatar.telegram {\r\n  background: linear-gradient(135deg, #229ED9 0%, #16BFFD 100%);\r\n}\r\n\r\n.chat-avatar.slack {\r\n  background: linear-gradient(135deg, #2EB67D 0%, #36C5F0 100%);\r\n}\r\n\r\n.chat-item-content {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.chat-item-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.chat-item-name {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #262626;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.chat-item-time {\r\n  font-size: 12px;\r\n  color: #8e8e8e;\r\n  flex-shrink: 0;\r\n  margin-left: 8px;\r\n}\r\n\r\n.chat-item-preview {\r\n  font-size: 14px;\r\n  color: #8e8e8e;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.chat-item-bot {\r\n  display: inline-block;\r\n  font-size: 11px;\r\n  background-color: #f0f0f0;\r\n  color: #666;\r\n  padding: 2px 8px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.chat-list-item.active .chat-item-bot {\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n.chat-item-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: 6px;\r\n}\r\n\r\n.auto-response-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.auto-response-dot.enabled {\r\n  background-color: #155724;\r\n  box-shadow: 0 0 0 2px #d4edda;\r\n}\r\n\r\n.auto-response-dot.disabled {\r\n  background-color: #721c24;\r\n  box-shadow: 0 0 0 2px #f8d7da;\r\n}\r\n\r\n.chat-item-country-flag {\r\n  width: 16px;\r\n  height: 12px;\r\n  border-radius: 2px;\r\n  flex-shrink: 0;\r\n  object-fit: cover;\r\n}\r\n\r\n.chat-header-country-flag {\r\n  width: 24px;\r\n  height: 18px;\r\n  border-radius: 3px;\r\n  flex-shrink: 0;\r\n  object-fit: cover;\r\n}\r\n\r\n/* ========== RIGHT SIDE - Chat View ========== */\r\n.chat-main {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #fff;\r\n  min-width: 0;\r\n}\r\n\r\n.chat-main-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 12px 20px;\r\n  border-bottom: 1px solid #efefef;\r\n  background-color: #fff;\r\n  min-height: 56px;\r\n  height: 56px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.chat-main-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.chat-main-avatar {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #5616ea 0%, #8b5cf6 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.chat-main-avatar-icon {\r\n  color: white;\r\n  font-size: 16px;\r\n}\r\n\r\n.chat-main-avatar.facebook {\r\n  background: linear-gradient(135deg, #1877f2 0%, #42a5f5 100%);\r\n}\r\n\r\n.chat-main-avatar.instagram {\r\n  background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\r\n}\r\n\r\n.chat-main-avatar.whatsapp {\r\n  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);\r\n}\r\n\r\n.chat-main-info h3 {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #262626;\r\n  margin: 0;\r\n}\r\n\r\n.chat-main-info span {\r\n  font-size: 12px;\r\n  color: #8e8e8e;\r\n}\r\n\r\n/* Auto-response toggle in header */\r\n.auto-response-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.toggle-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 13px;\r\n  color: #666;\r\n}\r\n\r\n/* In place of the AI switch when the chat's channel is no longer connected to the agent */\r\n.inbox-channel-disconnected {\r\n  font-size: 13px;\r\n  color: #666;\r\n  text-align: right;\r\n  max-width: 320px;\r\n}\r\n\r\n.toggle-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 5px 10px;\r\n  border: none;\r\n  border-radius: 16px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.toggle-button.enabled {\r\n  background-color: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.toggle-button.enabled:hover {\r\n  background-color: #c3e6cb;\r\n}\r\n\r\n.toggle-button.disabled {\r\n  background-color: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n.toggle-button.disabled:hover {\r\n  background-color: #f5c6cb;\r\n}\r\n\r\n.toggle-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.toggle-button svg {\r\n  font-size: 16px;\r\n}\r\n\r\n/* Chat messages container with sticky header */\r\n.chat-messages-container {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  overflow: hidden;\r\n  min-height: 0;\r\n}\r\n\r\n/* Sticky date header */\r\n.chat-sticky-date {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 8px 0;\r\n  margin: 0 0 -28px 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.chat-sticky-date.hidden {\r\n  visibility: hidden;\r\n}\r\n\r\n.chat-sticky-date-text {\r\n  background-color: #f0f0f0;\r\n  color: #8e8e8e;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  padding: 4px 12px;\r\n  border-radius: 12px 12px 8px 12px;\r\n}\r\n\r\n/* Date separator between message groups */\r\n.chat-date-separator {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 8px 0;\r\n  margin: 4px 0;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* First date separator should have no top margin */\r\n.chat-date-separator:first-child {\r\n  margin-top: 0;\r\n  padding-top: 0;\r\n}\r\n\r\n.chat-date-separator-text {\r\n  background-color: #f0f0f0;\r\n  color: #8e8e8e;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  padding: 4px 12px;\r\n  border-radius: 12px;\r\n  transition: opacity 0.15s ease;\r\n  opacity: 1;\r\n}\r\n\r\n/* Hide separator text when it's at the sticky position - use opacity for smooth transition */\r\n.chat-date-separator.at-sticky .chat-date-separator-text {\r\n  opacity: 0;\r\n}\r\n\r\n/* Chat messages area */\r\n.chat-messages {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 20px;\r\n  padding-top: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  background-color: #fff;\r\n}\r\n\r\n.chat-message {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.chat-message.assistant-message {\r\n  align-self: flex-start;\r\n  align-items: flex-start;\r\n  width: 100%;\r\n}\r\n\r\n.chat-message.user-history-message {\r\n  align-self: flex-end;\r\n  align-items: flex-end;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  max-width: none;\r\n}\r\n\r\n/* Stack user row and timestamp; align to the right */\r\n.user-message-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 4px;\r\n}\r\n\r\n/* Keep FAQ button and bubble aligned on the same center line */\r\n.user-message-body {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.message-bubble-history {\r\n  padding: 6px 10px !important;\r\n  border-radius: 12px;\r\n  font-size: 15px;\r\n  line-height: 1.4;\r\n  word-wrap: break-word;\r\n  background-color: #efefef;\r\n  color: #262626;\r\n}\r\n\r\n.user-history-message .message-bubble-history {\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  border-bottom-right-radius: 4px;\r\n}\r\n\r\n.assistant-message .message-bubble-history {\r\n  background: #efefef;\r\n  color: #262626;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  padding: 6px 10px !important;\r\n  border-radius: 12px 12px 12px 4px;\r\n  max-width: 70%;\r\n}\r\n\r\n/* Match chatModal bot markdown spacing */\r\n.assistant-message .message-bubble-history p {\r\n  margin: 0 0 .9em;\r\n}\r\n\r\n.assistant-message .message-bubble-history h1,\r\n.assistant-message .message-bubble-history h2,\r\n.assistant-message .message-bubble-history h3,\r\n.assistant-message .message-bubble-history h4,\r\n.assistant-message .message-bubble-history h5,\r\n.assistant-message .message-bubble-history h6 {\r\n  font-size: 1em;\r\n  line-height: inherit;\r\n  margin: 0 0 .9em;\r\n}\r\n\r\n.assistant-message .message-bubble-history ul,\r\n.assistant-message .message-bubble-history ol {\r\n  margin: .9em 0;\r\n  padding-left: 1.25em;\r\n}\r\n\r\n.assistant-message .message-bubble-history li {\r\n  margin: .25em 0;\r\n}\r\n\r\n.assistant-message .message-bubble-history table {\r\n  margin: .9em 0;\r\n}\r\n\r\n.assistant-message .message-bubble-history > :first-child {\r\n  margin-top: 0;\r\n  padding-top: 0;\r\n}\r\n\r\n.assistant-message .message-bubble-history > :last-child {\r\n  margin-bottom: 0;\r\n  padding-top: 0;\r\n}\r\n\r\n.assistant-message .message-bubble-history a {\r\n  color: #5616ea;\r\n  font-weight: 500;\r\n  text-decoration: underline;\r\n}\r\n\r\n.user-history-message .message-bubble-history a {\r\n  color: #fff;\r\n}\r\n\r\n.message-bubble-history p {\r\n  margin: 0;\r\n}\r\n\r\n.message-bubble-history strong {\r\n  font-weight: 600;\r\n}\r\n\r\n.message-bubble-history em {\r\n  font-style: italic;\r\n}\r\n\r\n.message-bubble-history a {\r\n  color: #5616ea;\r\n  text-decoration: underline;\r\n}\r\n\r\n.message-bubble-history ul,\r\n.message-bubble-history ol {\r\n  padding-left: 20px;\r\n  margin: 8px 0;\r\n}\r\n\r\n.message-bubble-history li {\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.message-bubble-history code {\r\n  background-color: rgba(0, 0, 0, 0.05);\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-family: monospace;\r\n  font-size: 13px;\r\n}\r\n\r\n.message-bubble-history table {\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  margin: 10px 0;\r\n  width: 100%;\r\n  font-size: 13px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.message-bubble-history th,\r\n.message-bubble-history td {\r\n  border: 1px solid rgba(0, 0, 0, 0.08);\r\n  padding: 6px 10px;\r\n  text-align: left;\r\n}\r\n\r\n.message-bubble-history th {\r\n  background-color: rgba(0, 0, 0, 0.04);\r\n  font-weight: 600;\r\n}\r\n\r\n/* Message content wrapper for user messages */\r\n.message-content-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n}\r\n\r\n.message-time {\r\n  font-size: 11px;\r\n  color: #8e8e8e;\r\n  padding: 0px;\r\n  margin-bottom: 4px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.assistant-message .message-time {\r\n  align-self: flex-start;\r\n}\r\n\r\n.user-history-message .message-time {\r\n  align-self: flex-end;\r\n}\r\n\r\n/* Sources */\r\n.sources-container {\r\n  margin: 0;\r\n}\r\n\r\n.sources-button {\r\n  background: none;\r\n  border: 1px solid #dbdbdb;\r\n  color: #666;\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 8px;\r\n  padding: 4px 10px;\r\n  outline: none;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.sources-button:hover {\r\n  background: #fafafa;\r\n  border-color: #c0c0c0;\r\n}\r\n\r\n.sources-toggle-icon {\r\n  margin-left: 6px;\r\n  font-size: 10px;\r\n}\r\n\r\n.sources-list {\r\n  max-height: 0;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.sources-list.expanded {\r\n  max-height: 200px;\r\n  opacity: 1;\r\n  margin-top: 6px;\r\n}\r\n\r\n.source-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 10px;\r\n  margin-bottom: 4px;\r\n  background: #fafafa;\r\n  border-radius: 8px;\r\n  font-size: 11px;\r\n  color: #5616ea;\r\n  text-decoration: none;\r\n  transition: background 0.2s ease;\r\n}\r\n\r\n.source-link:hover {\r\n  background: #f0f0f0;\r\n}\r\n\r\n.globe-icon {\r\n  font-size: 12px;\r\n  color: #5616ea;\r\n}\r\n\r\n/* Add FAQ button */\r\n.add-faq-button {\r\n  display: flex;\r\n  align-items: center;\r\n  align-self: center;\r\n  line-height: 1; /* keep text centered without relying on offsets */\r\n  gap: 4px;\r\n  border-radius: 14px;\r\n  padding: 4px 10px;\r\n  background-color: transparent;\r\n  border: 1px solid #dbdbdb;\r\n  color: #5616ea;\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n  transition: all 0.2s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.add-faq-button:hover {\r\n  background-color: #fafafa;\r\n  border-color: #5616ea;\r\n}\r\n\r\n/* Chat input area - styled like chatModal */\r\n/* Website chats: why/until when the team can reply after the chat ended */\r\n.followup-note {\r\n  padding: 8px 12px;\r\n  border-top: 1px solid #f1f1f1;\r\n  background-color: #fafafa;\r\n  color: #6b7280;\r\n  font-size: 12px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.followup-note a {\r\n  color: #5616ea;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n}\r\n\r\n.followup-note a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.followup-note + .chat-input-area {\r\n  border-top: none;\r\n}\r\n\r\n.chat-input-area {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 10px;\r\n  border-top: 1px solid #f1f1f1;\r\n  background-color: #fafafa;\r\n}\r\n\r\n.chat-input-wrapper {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.chat-input-wrapper textarea {\r\n  flex: 1;\r\n  border: 1px solid #ccc;\r\n  background: #fff;\r\n  padding: 6px 10px;\r\n  font-size: 16px;\r\n  resize: none;\r\n  outline: none;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  line-height: 1.4;\r\n  max-height: 140px;\r\n  overflow-y: hidden;\r\n  border-radius: 8px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.chat-input-wrapper textarea:focus {\r\n  border-color: #5616ea;\r\n}\r\n\r\n.chat-input-wrapper textarea::placeholder {\r\n  color: #8e8e8e;\r\n}\r\n\r\n.chat-input-wrapper textarea:disabled {\r\n  background-color: #f5f5f5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.send-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 15px;\r\n  height: 34px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background-color: #5616ea;\r\n  color: white;\r\n  cursor: pointer;\r\n  transition: background-color 0.4s ease, transform 0.2s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.send-button:hover:not(:disabled) {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1.5px);\r\n}\r\n\r\n.send-button:disabled {\r\n  background-color: #c0c0c0;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.send-button .send-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n  fill: currentColor;\r\n  display: block;\r\n}\r\n\r\n/* Empty state */\r\n.chat-empty-state {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #8e8e8e;\r\n  padding: 40px;\r\n  text-align: center;\r\n}\r\n\r\n.chat-empty-state svg {\r\n  font-size: 48px;\r\n  margin-bottom: 16px;\r\n  color: #dbdbdb;\r\n}\r\n\r\n.chat-empty-state h3 {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #262626;\r\n  margin: 0 0 8px 0;\r\n}\r\n\r\n.chat-empty-state p {\r\n  font-size: 14px;\r\n  margin: 0;\r\n}\r\n\r\n/* ========== Responsive ========== */\r\n@media (max-width: 900px) {\r\n  .chat-history-overview {\r\n    height: auto;\r\n    flex-direction: column;\r\n    min-height: 600px;\r\n  }\r\n\r\n  .chat-sidebar {\r\n    width: 100%;\r\n    min-width: 100%;\r\n    max-height: 280px;\r\n    border-right: none;\r\n    border-bottom: 1px solid #efefef;\r\n  }\r\n\r\n  .chat-sidebar-header {\r\n    padding: 10px 16px;\r\n    min-height: 48px;\r\n    height: 48px;\r\n  }\r\n\r\n  .chat-main {\r\n    flex: 1;\r\n    min-height: 350px;\r\n  }\r\n\r\n  .chat-main-header {\r\n    min-height: 48px;\r\n    height: auto;\r\n    padding: 10px 16px;\r\n  }\r\n\r\n  .chat-message.assistant-message,\r\n  .chat-message.user-history-message {\r\n    max-width: 90%;\r\n  }\r\n\r\n  .assistant-message .message-bubble-history {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .chat-history-overview {\r\n    min-height: 500px;\r\n    border-radius: 0;\r\n  }\r\n\r\n  .chat-sidebar {\r\n    max-height: 240px;\r\n  }\r\n\r\n  .chat-sidebar-header {\r\n    padding: 10px 12px;\r\n    gap: 8px;\r\n  }\r\n\r\n  .header-title {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .search-input {\r\n    font-size: 16px; /* Prevent iOS zoom on focus */\r\n  }\r\n\r\n  .chat-list-item {\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .chat-avatar {\r\n    width: 38px;\r\n    height: 38px;\r\n    margin-right: 10px;\r\n  }\r\n\r\n  .chat-avatar-icon {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .chat-item-name {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .chat-item-time {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .chat-item-preview {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .chat-item-bot {\r\n    font-size: 10px;\r\n    padding: 2px 6px;\r\n  }\r\n\r\n  .chat-main-header {\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    align-items: flex-start;\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .chat-main-info h3 {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .auto-response-toggle {\r\n    width: 100%;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .toggle-label {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .toggle-button {\r\n    font-size: 11px;\r\n    padding: 4px 8px;\r\n  }\r\n\r\n  .chat-messages {\r\n    padding: 10px;\r\n    gap: 6px;\r\n  }\r\n\r\n  .chat-message.assistant-message,\r\n  .chat-message.user-history-message {\r\n    max-width: 95%;\r\n  }\r\n\r\n  .message-bubble-history {\r\n    font-size: 14px;\r\n    padding: 5px 8px !important;\r\n  }\r\n\r\n  .assistant-message .message-bubble-history {\r\n    font-size: 14px;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .message-time {\r\n    font-size: 10px;\r\n  }\r\n\r\n  .chat-date-separator-text,\r\n  .chat-sticky-date-text {\r\n    font-size: 11px;\r\n    padding: 3px 10px;\r\n  }\r\n\r\n  .sources-button {\r\n    font-size: 10px;\r\n    padding: 3px 8px;\r\n  }\r\n\r\n  .source-link {\r\n    font-size: 10px;\r\n    padding: 5px 8px;\r\n  }\r\n\r\n  .add-faq-button {\r\n    font-size: 10px;\r\n    padding: 3px 8px;\r\n    gap: 3px;\r\n  }\r\n\r\n  .user-message-body {\r\n    gap: 6px;\r\n  }\r\n\r\n  .chat-input-area {\r\n    padding: 8px 10px;\r\n    gap: 8px;\r\n  }\r\n\r\n  .chat-input-wrapper textarea {\r\n    font-size: 16px; /* Prevent iOS zoom on focus */\r\n    padding: 8px 10px;\r\n    min-height: 36px;\r\n  }\r\n\r\n  .send-button {\r\n    height: 36px;\r\n    padding: 0 12px;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .send-button .send-icon {\r\n    width: 14px;\r\n    height: 14px;\r\n  }\r\n\r\n  .chat-empty-state {\r\n    padding: 24px 16px;\r\n  }\r\n\r\n  .chat-empty-state svg {\r\n    font-size: 36px;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .chat-empty-state h3 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .chat-empty-state p {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n/* Extra small devices */\r\n@media (max-width: 400px) {\r\n  .chat-sidebar {\r\n    max-height: 200px;\r\n  }\r\n\r\n  .chat-avatar {\r\n    width: 34px;\r\n    height: 34px;\r\n    margin-right: 8px;\r\n  }\r\n\r\n  .chat-item-name {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .chat-item-preview {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .message-bubble-history {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .assistant-message .message-bubble-history {\r\n    font-size: 13px;\r\n  }\r\n}\r\n/* Lazy-loaded transcript states (spinner while the session's messages\r\n   fetch, inline error + retry when that fetch fails). */\r\n.chat-messages-state {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  color: #5616ea;\r\n  font-size: 18px;\r\n}\r\n\r\n.chat-messages-state p {\r\n  margin: 0;\r\n  color: #6b7280;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Empty search result inside the session list */\r\n.chat-list-empty {\r\n  padding: 24px 16px;\r\n  text-align: center;\r\n  color: #6b7280;\r\n  font-size: 14px;\r\n}\r\n\r\n/* the product cards under an answer (ProductCarousel), as in the chat widget */\r\n.history-products {\r\n  width: 100%;\r\n  max-width: 620px;\r\n  margin-top: 6px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
